import { render, staticRenderFns } from "./posts.vue?vue&type=template&id=e73f4644&scoped=true"
import script from "./posts.vue?vue&type=script&lang=js"
export * from "./posts.vue?vue&type=script&lang=js"
import style0 from "./posts.vue?vue&type=style&index=0&id=e73f4644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73f4644",
  null
  
)

export default component.exports